import { legacyPlugins } from "/opt/build/repo/node_modules/.pnpm/@unhead+vue@3.4.0_@oxc-project+types@0.149.0_@vitejs+devtools-kit@0.4.8_cac@7.0.0_rolld_1fc94b22efffc27d7612e6ffa20bc63f/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}